import { Navigate } from 'react-router-dom';

import useAuthentication from '../hooks/useAuthentication';

const Root = () => {
    const { currentUser } = useAuthentication();
    return currentUser?.id ? <Navigate to="/main" replace /> : <Navigate to="/login" replace />;
}

export default Root;
